import React, { useCallback, useEffect, useState } from 'react'
import { MasonryLayoutCompany } from '../../../../components/layouts'
import { Box, CircularProgress, styled, Typography } from '@mui/material'
import { useForm } from 'react-hook-form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faMapMarker,
  faEnvelope,
  faPhone,
  faArrowLeft,
  faPen,
  faCircleExclamation,
  faHome,
  faCircleCheck,
} from '@fortawesome/pro-regular-svg-icons'
import lightTheme from '../../../../styles/theme/lightTheme'
import {
  ChoiceOfferModal,
  EditDocuments,
  EditEvent,
  EditInfos,
  EditList,
  EditPasswordModal,
} from '../../../../components/modals'
import { BiBlockTable, GedTable } from '../../../../components/tables'
import Api from '../../../../services/api.service'
import { handlingErrors } from '../../../../utils'
import { Slide, ToastContainer, toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import Button from '@mui/material/Button'
import moment from 'moment-timezone'
import EditBesoinEntreprise from '../../../../components/modals/EditBesoinEntreprise'
import DeleteGeneralModal from '../../../../components/modals/DeleteGeneralModal'
import EditCommentaire from '../../../../components/modals/EditCommentaire'
import BesoinTable from '../../../../components/tables/BesoinTable'
import { ROLE_ENTREPRISE, VALEURS } from '../../../../data'
import DetailBesoinEntreprise from '../../../../components/modals/DetailBesoinEntreprise'
import OffreEntrepriseTable from '../../../../components/tables/OffreEntrepriseTable'
import EditDisponibilite from '../../../../components/modals/EditDisponibilite'
import { faCalendar, faLeaf } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import CandidatureTable from '../../../../components/tables/CandidatureTable'
import DetailCandidature from '../../../../components/modals/DetailCandidature'
import ChoiceOfferModalEntreprise from '../../../../components/modals/ChoiceOfferModalEntreprise'

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} disableShrink />
    </Box>
  )
}

const ProfilContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '32px',
  justifyContent: 'space-between',
  position: 'relative',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  borderRadius: '16px',
  padding: '24px',
  color: 'white',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
  },
}))

const BannerProfil = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: 48,
  backgroundColor: 'rgba(255, 255, 255, 0.15)',
  backdropFilter: 'blur(10px)',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '12px 16px',
  borderRadius: '12px',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    transform: 'translateX(4px)',
  },
}))

const WrapperBanner = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '10px',
}))

const BannerProfilContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '10px',
}))

const TitleSection = styled(Typography)(({ theme }) => ({
  fontFamily: 'Century Gothic Bold',
  fontSize: 16,
  lineHeight: '140%',
  letterSpacing: '0.2px',
  color: 'white',
  textTransform: 'uppercase',
  textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
}))

const TitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

const WrapperProfilText = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  rowGap: '12px',
  textAlign: 'center',
  padding: '16px 0',
}))

const IconContainer = styled(Box)(({ theme }) => ({
  width: 36,
  height: 36,
  border: '2px solid rgba(255, 255, 255, 0.3)',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(10px)',
  transition: 'all 0.3s ease',

  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    border: '2px solid rgba(255, 255, 255, 0.5)',
    transform: 'scale(1.1)',
  },

  '&:active': {
    transform: 'scale(0.95)',
  },
}))

const CompanyProfil = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [openCalendar, setOpenCalendar] = useState(false)
  const [openDoc, setOpenDoc] = useState(false)
  const [openBesoin, setOpenBesoin] = useState(false)
  const [openDetailBesoin, setOpenDetailBesoin] = useState(false)
  const [openDetailCandidature, setOpenDetailCandidature] = useState(false)
  const [openCommentaire, setOpenCommentaire] = useState(false)
  const [openValeurs, setOpenValeurs] = useState(false)
  const [loading, setLoading] = useState(true)
  const [dateRdv, setDateRdv] = useState([])
  const [dateRdvPasse, setDateRdvPasse] = useState([])
  const [snapShot, setSnapShot] = useState(null)
  const dispatch = useDispatch()
  //const [content, setContent] = useState([])
  const [besoins, setBesoins] = useState([])
  const [candidatures, setCandidatures] = useState([])
  const [besoin, setBesoin] = useState([])
  const [candidature, setCandidature] = useState([])
  const [commentaire, setCommentaire] = useState([])
  const [role, setRole] = useState('')
  const [isFile, setIsFile] = useState([])
  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    setOpen(false)
    //fetchData()
  }
  const handleOpenCalendar = () => {
    setOpenCalendar(true)
  }
  const handleCloseCalendar = () => {
    setOpenCalendar(false)
    //fetchData()
  }
  const handleOpenDoc = () => setOpenDoc(true)
  const handleCloseDoc = () => {
    setOpenDoc(false)
    //fetchData()
  }
  const handleOpenValeurs = () => setOpenValeurs(true)
  const handleCloseValeurs = () => {
    setOpenValeurs(false)
    //fetchData()
  }
  const handleOpenCommentaire = () => setOpenCommentaire(true)
  const handleCloseCommentaire = () => {
    setOpenCommentaire(false)
    //fetchData()
  }
  const handleOpenBesoin = () => {
    navigate(
      '/admin/annonces/create/' + params.userId + '/' + snapShot.entreprise?.id
    )
    /* setOpenBesoin(true)
    setBesoin('') */
  }
  const handleCloseBesoin = () => {
    setOpenBesoin(false)
    //fetchData()
  }
  const handleCloseDetailBesoin = () => {
    setOpenDetailBesoin(false)
    //fetchData()
  }
  const handleCloseDetailCandidature = useCallback(() => {
    setOpenDetailCandidature(false)
  }, [])
  const handleSaveDetailCandidature = useCallback(() => {
    getCandidatures(snapShot.id, pageCandidature, 'entreprise')
    setOpenDetailCandidature(false)
  }, [])
  const handleSaveBesoin = () => {
    setOpenBesoin(false)
    getBesoinsCompany(snapShot.entreprise?.id, page)
  }

  const handleSaveBesoinPublish = () => {
    setOpenBesoin(false)
    fetchData()
  }

  const params = useParams()
  const handleRemoveBesoin = (idBesoin) => {
    setOpenDeleteBesoinModal(true)
    setBesoinId(idBesoin)
  }
  const handlePageChange = (event, page) => {
    setPage(page)
    getBesoinsCompany(snapShot.entreprise?.id, page)
  }
  const handlePageCandidatureChange = (event, page) => {
    setPageCandidature(page)
    getCandidatures(page)
  }
  const handleEditBesoin = (besoin) => {
    setOpenBesoin(true)
    setBesoin(besoin)
  }
  const handleDetailBesoin = (besoin) => {
    setOpenDetailBesoin(true)
    setBesoin(besoin)
  }
  const handleDetailCandidature = (candidature) => {
    //navigate(`/offres-emploi/${candidature?.besoinEntreprise?.id}`)

    setOpenDetailCandidature(true)
    setCandidature(candidature)
  }
  const handleRemove = (idFile) => {
    setOpenDeleteModal(true)
    setFileDelete(idFile)
  }
  const handleOpenOffer = () => setOpenOffre(true)
  const handleCloseOffer = () => {
    setOpenOffre(false)
    //fetchData()
  }

  const handleSave = () => {
    fetchData()
    setOpen(false)
    setOpenDoc(false)
    setOpenBesoin(false)
    setOpenCommentaire(false)
    setOpenValeurs(false)
  }

  const handleSaveDisponibilite = () => {
    toast.success('Les disponibilités ont bien été mise à jour !', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
      icon: ({ theme, type }) => (
        <FontAwesomeIcon
          icon={faCircleCheck}
          fontSize={25}
          color={lightTheme.palette.success.main}
        />
      ),
    })
    setOpenCalendar(false)
    setTimeout(function () {
      fetchData()
    }, 1000)
  }

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [openDeleteBesoinModal, setOpenDeleteBesoinModal] = useState(false)
  const handleCloseDeleteModal = () => setOpenDeleteModal(false)
  const handleConfirmDeleteModal = () => removeFile()
  const handleCloseDeleteBesoinModal = () => setOpenDeleteBesoinModal(false)
  const handleConfirmDeleteBesoinModal = () => removeBesoin()
  const [loadingDelete, setLoadingDelete] = useState(false)
  const [fileDelete, setFileDelete] = useState()
  const [besoinId, setBesoinId] = useState()

  const [openOffre, setOpenOffre] = useState(false)
  const [offres, setOffres] = useState([])
  const [companySubscriptions, setCompanySubscriptions] = useState([])
  const [offreSelect, setOffreSelect] = useState('')
  /*  const [offresSelect, setOffresSelect] = useState([])
  const [loadingOffer, setLoadingOffer] = useState(true) */
  const [loadingBesoin, setLoadingBesoin] = useState(true)
  const [loadingCandidatures, setLoadingCandidatures] = useState(true)
  const [loadingButton, setLoadingButton] = useState(false)
  const { handleSubmit } = useForm({ mode: 'onBlur' })
  const [page, setPage] = useState(1)
  const [pageCandidature, setPageCandidature] = useState(1)
  const [count, setCount] = useState(0)
  const [countCandidatures, setCountCandidatures] = useState(0)

  const [openEvent, setOpenEvent] = useState(false)
  const [event, setEvent] = useState({})

  const handleOpenEvent = (event) => {
    setEvent(event)
    setOpenEvent(true)
  }
  const handleCloseEvent = () => {
    setOpenEvent(false)
    fetchData()
  }
  const getBesoinsCompany = async (idCompany, page) => {
    setLoadingBesoin(true)
    try {
      let result = await Api.besoinEntreprise.listWithFilter({
        entreprise: idCompany,
        page: page,
        itemsPerPage: 5,
      })

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        setLoadingBesoin(false)
        toast.error('Votre session à expiré ! Merci de vous reconnecter.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
        return
      }

      if (handling.ok) {
        const res = handling
        setLoadingBesoin(false)
        setBesoins(res.data['hydra:member'])
        setCount(res.data['hydra:totalItems'])
      } else {
        setLoadingBesoin(false)
        window.scrollTo(0, 0)
      }
    } catch (error) {
      setLoadingBesoin(false)
      toast.error(
        "Quelque chose s'est mal passé ! Merci de réessayer plus tard.",
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        }
      )
      window.scrollTo(0, 0)
    }
  }
  useEffect(() => {
    getOffers()
  }, [])

  const getOffers = async () => {
    try {
      let result = await Api.siteVitrine.getSubscriptionPlans({})

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        //setLoadingOffer(false)
        toast.error('Votre session à expiré ! Merci de vous reconnecter.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
        return
      }

      if (handling.ok) {
        const res = handling.data
        //setLoadingOffer(false)
        setOffres(res)
      } else {
        //setLoadingOffer(false)
        window.scrollTo(0, 0)
      }
    } catch (error) {
      //setLoadingOffer(false)
      toast.error(
        "Quelque chose s'est mal passé ! Merci de réessayer plus tard.",
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        }
      )
      window.scrollTo(0, 0)
    }
  }

  const getCandidatures = async (id, page, roleUser) => {
    setLoadingCandidatures(true)
    try {
      let result = await Api.candidature.listWithFilter({
        ['besoinEntreprise.entreprise.profile']: id,
        page: page,
      })

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        setLoadingCandidatures(false)
        toast.error(t('successMessage.sessionExpired'), {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
        return
      }

      if (handling.ok) {
        const res = handling
        setLoadingCandidatures(false)
        setCandidatures(res.data['hydra:member'])
        setCountCandidatures(res.data['hydra:totalItems'])
      } else {
        setLoadingCandidatures(false)
        window.scrollTo(0, 0)
      }
    } catch (error) {
      setLoadingCandidatures(false)
      toast.error(t('successMessage.somethingWrong'), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        icon: ({ theme, type }) => (
          <FontAwesomeIcon
            icon={faCircleExclamation}
            fontSize={25}
            color={lightTheme.palette.error.main}
          />
        ),
      })
      window.scrollTo(0, 0)
    }
  }

  const handleChangeSelect = (evt) => {
    const inputValue = evt.target.value
    setOffreSelect(inputValue)
  }

  const handleClickOffreEntreprise = (durreSelect, statusSelect) => {
    handleSubmit(onSubmit(durreSelect, statusSelect))
  }

  const onSubmit = async (durreSelect, statusSelect) => {
    setLoadingButton(true)

    const start = new Date()
    const end = new Date()

    console.log('type:', typeof durreSelect.value)

    if (durreSelect.type === 'days') {
      end.setDate(end.getDate() + Number(durreSelect.value))
    } else if (durreSelect.type === 'months') {
      end.setMonth(end.getMonth() + Number(durreSelect.value))
    }

    /* console.log(start.toISOString())
    console.log(end.toISOString())
    return */

    let offresSelect = {
      subscriptionPlan: `/api/subscription_plans/${offreSelect.id}`,
      basePrice: offreSelect.basePrice ? parseInt(offreSelect.basePrice) : 0,
      finalPrice: offreSelect.basePrice ? parseInt(offreSelect.basePrice) : 0,
      credits: offreSelect.maxJobPostings,
      startDate: start,
      endDate: end,
      status: statusSelect,
      utilisateur: `/api/utilisateurs/${snapShot.id}`,
    }
    //setOffresSelect(offresSelect)

    try {
      const result = await Api.offerUtilisateur.add(offresSelect, snapShot.role)

      const handling = handlingErrors(result)

      if (handling.ok) {
        //const res = handling.data
        //setSnapShot(res);
        setLoadingButton(false)
        setOpenOffre(false)
        fetchData()
        toast.success('La proposition a bien été envoyée!', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleCheck}
              fontSize={25}
              color={lightTheme.palette.success.main}
            />
          ),
        })
      }
    } catch (error) {
      setLoadingButton(false)
    }
  }

  const removeBesoin = async () => {
    setLoadingDelete(true)
    try {
      let result = await Api.besoinEntreprise.delete(besoinId)

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        toast.error('Votre session à expiré, merci de vous reconnecter.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
      }

      if (handling.ok) {
        const indexBesoin = besoins.findIndex((bs) => bs.id === besoinId)

        if (indexBesoin > -1) {
          besoins.splice(indexBesoin, 1)
        }
        setBesoins(besoins)
        setOpenDeleteBesoinModal(false)
      } else {
        window.scrollTo(0, 0)
      }
    } catch (error) {
      toast.error(
        "Quelque chose s'est mal passé ! Merci de réessayer plus tard.",
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        }
      )
    }
    setLoadingDelete(false)
    setBesoinId('')
  }
  const removeFile = async () => {
    setLoadingDelete(true)
    try {
      let result = await Api.document.delete(fileDelete)

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        toast.error('Votre session à expiré, merci de vous reconnecter.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
      }

      if (handling.ok) {
        const indexFile = isFile.findIndex((file) => file.id === fileDelete)

        if (indexFile > -1) {
          isFile.splice(indexFile, 1)
        }
        setIsFile(isFile)
        setOpenDeleteModal(false)
      } else {
        window.scrollTo(0, 0)
      }
    } catch (error) {
      toast.error(
        "Quelque chose s'est mal passé ! Merci de réessayer plus tard.",
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        }
      )
    }
    setLoadingDelete(false)
  }
  const fetchData = async () => {
    try {
      let result = await Api.user.detail(params.userId)

      //setContent(result.data)

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        toast.error('Votre session à expiré, merci de vous reconnecter.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
      }

      if (handling.ok) {
        const res = handling.data
        getBesoinsCompany(res.entreprise?.id)
        setSnapShot(res)
        setLoading(false)
        setRole(res.role)
        const currentDate = new Date()

        getCandidatures(res.id, pageCandidature, 'entreprise')
        setDateRdv(
          res.entreprise?.calendriers
            .filter((item) => currentDate < new Date(item.dateDebut))
            .sort((a, b) => a.id - b.id)
        )
        setDateRdvPasse(
          res.entreprise?.calendriers
            .filter((item) => new Date(item.dateDebut) < currentDate)
            .sort((a, b) => a.id - b.id)
        )
        setCommentaire(res.commentaire)
        setCompanySubscriptions(res.companySubscriptions)
        /*  let userOffres = []
        if (res.entrepriseOffres) {
          res.entrepriseOffres.map((userOffre, i) => {
            userOffres.push({
              id: userOffre.id,
              offre: `/api/offres_entreprises/${userOffre.offre.id}`,
              prix: userOffre.prix,
            })
          })
        }
        setOffresSelect(userOffres) */

        let docs = []
        if (res.documents) {
          res.documents.map((doc, i) => {
            docs.push(doc)
          })
        }

        setIsFile(docs)
      } else {
        setLoading(false)
        window.scrollTo(0, 0)
      }
    } catch (error) {
      setLoading(false)
      toast.error(
        "Quelque chose s'est mal passé ! Merci de réessayer plus tard.",
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        }
      )
    }
  }
  useEffect(() => {
    if (params.userId) fetchData()
  }, [params.userId, dispatch])

  const handlePayementOffre = (offre) => {}

  const [openPasswordModal, setOpenPasswordModal] = useState(false)
  const handleOpenPassword = () => setOpenPasswordModal(true)
  const handleClosePassword = () => setOpenPasswordModal(false)

  const onSuccessChangePassword = () => {
    toast.success('Le mot de passe a été modifié avec succès !', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
      icon: ({ theme, type }) => (
        <FontAwesomeIcon
          icon={faCircleCheck}
          fontSize={25}
          color={lightTheme.palette.success.main}
        />
      ),
    })
    window.scrollTo(0, 0)
  }

  if (loading)
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <CircularProgress />
      </Box>
    )

  return (
    <div style={{ width: '100%' }}>
      <Button
        sx={{
          margin: '10px',
        }}
        onClick={() =>
          navigate('/admin/gestion-client/liste-clients-entreprises')
        }
      >
        <FontAwesomeIcon
          icon={faArrowLeft}
          fontSize={15}
          color={lightTheme.palette.primary.b2}
        />{' '}
        <Typography
          variant={'body2'}
          color={lightTheme.palette.primary.b2}
          textAlign={'right'}
          marginLeft={1}
        >
          {'Retour'}
        </Typography>
      </Button>
      <MasonryLayoutCompany
        type={'entreprise'}
        handleOpenDoc={handleOpenDoc}
        handleOpenBesoin={handleOpenBesoin}
        handleOpenCommentaire={handleOpenCommentaire}
        handleOpenOffer={handleOpenOffer}
        handleOpenValeurs={handleOpenValeurs}
        profil={
          <ProfilContainer>
            <TitleContainer>
              <TitleSection>{t('profile.title')}</TitleSection>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: 'auto',
                }}
              >
                <IconContainer sx={{ marginRight: '5px' }} onClick={handleOpen}>
                  <FontAwesomeIcon
                    icon={faPen}
                    fontSize={15}
                    color={lightTheme.palette.primary.b2}
                  />
                </IconContainer>
                <IconContainer onClick={handleOpenCalendar}>
                  <FontAwesomeIcon
                    icon={faCalendar}
                    fontSize={15}
                    color={lightTheme.palette.primary.b2}
                  />
                </IconContainer>
              </Box>
            </TitleContainer>
            <WrapperProfilText>
              <Typography
                sx={{
                  fontFamily: 'Century Gothic Bold',
                  fontSize: { xs: 20 },
                  lineHeight: '120%',
                  color: 'white',
                  textAlign: 'center',
                  textTransform: 'uppercase',
                }}
              >
                {snapShot.entreprise?.raisonSocial}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: 16 },
                  textAlign: 'center',
                  color: 'white',
                  textTransform: 'capitalize',
                }}
              >
                {snapShot.prenom} {snapShot.nom}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: 14 },
                  textAlign: 'center',
                  color: 'white',
                }}
              >
                {snapShot.entreprise?.fonctions?.titre}
              </Typography>
            </WrapperProfilText>
            <BannerProfilContainer>
              <WrapperBanner>
                {/* {user.langues?.length > 0 && (
                <BannerProfil>
                  <FontAwesomeIcon icon={faComment} />
                  <Typography>{user.langues}</Typography>
                </BannerProfil>
              )} */}
                <BannerProfil>
                  <FontAwesomeIcon icon={faMapMarker} />

                  <Typography
                    textAlign={'right'}
                    title={snapShot.adresse}
                    color={'white'}
                    style={{
                      width: '90%',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      lineHeight: '16px',
                    }}
                  >
                    {snapShot.adresse}
                  </Typography>
                </BannerProfil>
                <BannerProfil>
                  <FontAwesomeIcon icon={faHome} />
                  <Typography color={'white'}>
                    {snapShot.codePostal} / {snapShot.ville} / {snapShot.pays}
                  </Typography>
                </BannerProfil>
                <BannerProfil>
                  <FontAwesomeIcon icon={faEnvelope} />
                  <Typography
                    color={'white'}
                    textAlign={'right'}
                    title={snapShot.email}
                    style={{
                      width: '90%',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                    }}
                  >
                    {snapShot.email}
                  </Typography>
                </BannerProfil>
                <BannerProfil>
                  <FontAwesomeIcon icon={faPhone} />
                  <Typography color={'white'}>{snapShot.telephone}</Typography>
                </BannerProfil>
              </WrapperBanner>
              {/*<BorderButtonPurple>Voir le résumé</BorderButtonPurple>*/}
            </BannerProfilContainer>
          </ProfilContainer>
        }
        besoinClient={
          besoins && (
            <BesoinTable
              besoins={besoins}
              loading={loadingBesoin}
              handleRemove={handleRemoveBesoin}
              handleEdit={handleEditBesoin}
              handleDetailBesoin={handleDetailBesoin}
              handlePageChange={handlePageChange}
              count={count}
              page={page}
              role={'ROLE_ADMIN'}
              pageSize={5}
            />
          )
        }
        candidatures={
          candidatures && (
            <CandidatureTable
              candidatures={candidatures}
              loading={loadingCandidatures}
              handleDetailCandidature={handleDetailCandidature}
              handlePageChange={handlePageCandidatureChange}
              count={countCandidatures}
              page={pageCandidature}
              userData={snapShot}
            />
          )
        }
        commentaireAdmin={
          <Typography variant={'body2'} color={lightTheme.palette.grey.grey}>
            <div style={{ whiteSpace: 'pre-line' }}>{commentaire}</div>
          </Typography>
        }
        offre={
          snapShot.companySubscriptions && (
            <OffreEntrepriseTable
              offres={snapShot.companySubscriptions}
              handlePayementOffre={handlePayementOffre}
            />
          )
        }
        ged={
          isFile ? (
            <GedTable
              files={isFile}
              dateFile={moment(snapShot.date)
                .tz('Europe/Paris')
                .format('DD/MM/YYYY HH:mm')}
              handleRemove={handleRemove}
            />
          ) : (
            <GedTable />
          )
        }
        rendezVous={
          <BiBlockTable
            rdvAVenir={dateRdv}
            rdvPasse={dateRdvPasse}
            heureAVenir={''}
            handleOpenEvent={handleOpenEvent}
            type={'entreprise'}
            role={'ROLE_ADMIN'}
          />
        }
        feedback={dateRdv}
        displayCompetencesSection={'none'}
        competences={[]}
        displaySoftskilSection={'none'}
        softskils={[]}
        displayValeurSection={'display'}
        valeurs={snapShot.entreprise.valeurs}
      />

      {open && (
        <EditInfos
          open={open}
          onClose={handleClose}
          id={params.userId}
          onSave={handleSave}
          role={'ROLE_ADMIN'}
          type={role}
          handleOpenPassword={handleOpenPassword}
        />
      )}

      {openPasswordModal && (
        <EditPasswordModal
          open={openPasswordModal}
          onClose={handleClosePassword}
          id={params.userId}
          onSuccess={onSuccessChangePassword}
        />
      )}

      {openCommentaire && (
        <EditCommentaire
          open={openCommentaire}
          onClose={handleCloseCommentaire}
          onSave={handleSave}
          id={params.userId}
        />
      )}

      {openValeurs && (
        <EditList
          open={openValeurs}
          onClose={handleCloseValeurs}
          onSave={handleSave}
          id={snapShot.entreprise?.id}
          type={'valeurs'}
          values={snapShot.entreprise?.valeurs}
          datas={[...VALEURS['fr'], ...VALEURS['en']]}
          role={'entreprise'}
        />
      )}

      {openBesoin && (
        <EditBesoinEntreprise
          open={openBesoin}
          onClose={handleCloseBesoin}
          onSave={handleSaveBesoin}
          onSavePublish={handleSaveBesoinPublish}
          id={snapShot.entreprise?.id}
          besoin={besoin}
          role={'ROLE_ADMIN'}
        />
      )}

      {openDetailBesoin && (
        <DetailBesoinEntreprise
          open={openDetailBesoin}
          onClose={handleCloseDetailBesoin}
          besoin={besoin}
          role={'ROLE_ENTREPRISE'}
        />
      )}

      {openDoc && (
        <EditDocuments
          open={openDoc}
          onClose={handleCloseDoc}
          onSave={handleSave}
          id={params.userId}
          role={'ROLE_ENTREPRISE'}
        />
      )}

      {openOffre && (
        <ChoiceOfferModalEntreprise
          open={openOffre}
          onClose={handleCloseOffer}
          items={offres}
          handleClick={handleSubmit(onSubmit)}
          handleClickOffreEntreprise={handleClickOffreEntreprise}
          value={offreSelect}
          handleChange={handleChangeSelect}
          loading={loadingButton}
          role={'ROLE_ADMIN'}
          type={'entreprise'}
        />
      )}

      {openDeleteModal && (
        <DeleteGeneralModal
          open={openDeleteModal}
          onClose={handleCloseDeleteModal}
          onConfirm={handleConfirmDeleteModal}
          loading={loadingDelete}
        />
      )}

      {openDeleteBesoinModal && (
        <DeleteGeneralModal
          open={openDeleteBesoinModal}
          onClose={handleCloseDeleteBesoinModal}
          onConfirm={handleConfirmDeleteBesoinModal}
          loading={loadingDelete}
        />
      )}

      {openEvent && (
        <EditEvent
          open={openEvent}
          onClose={handleCloseEvent}
          id={params.userId}
          role={ROLE_ENTREPRISE}
          event={event}
          onSave={handleCloseEvent}
          showParams={true}
        />
      )}

      {openCalendar && (
        <EditDisponibilite
          open={openCalendar}
          onClose={handleCloseCalendar}
          onSave={handleSaveDisponibilite}
          user={snapShot}
        />
      )}

      {openDetailCandidature && (
        <DetailCandidature
          open={openDetailCandidature}
          onClose={handleCloseDetailCandidature}
          onSave={handleSaveDetailCandidature}
          candidature={candidature}
          role={ROLE_ENTREPRISE}
          toast={toast}
        />
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        closeButton={false}
        transition={Slide}
        className={'toast'}
      />
    </div>
  )
}

export default CompanyProfil
